(() => {
  function init(root = document) {
    root.querySelectorAll('.mas-product-experience').forEach(page => {
      if (page.dataset.editorialReady) return;
      const dialog = page.querySelector('.mas-size-dialog');
      const content = page.querySelector('[data-purchase-content]');
      if (!dialog?.showModal || !content) return;
      page.dataset.editorialReady = 'true';
      dialog.querySelector('[data-size-body]').append(content);
      let opener;
      page.querySelectorAll('[data-size-open], a[href^="#ProductForm-"]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => {
          event.preventDefault(); opener = link;
          if (!dialog.open) dialog.showModal();
        });
      });
      dialog.querySelector('[data-size-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener?.focus());
      const serviceDialog = page.querySelector('.mas-service-dialog');
      const serviceBody = serviceDialog.querySelector('[data-service-body]');
      const servicePanels = [...page.querySelectorAll('[data-service-content]')];
      servicePanels.forEach(panel => { panel.hidden = true; serviceBody.append(panel); });
      let serviceOpener;
      page.querySelectorAll('[data-service-open]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => {
          event.preventDefault(); serviceOpener = link;
          servicePanels.forEach(panel => { panel.hidden = panel.dataset.serviceContent !== link.dataset.serviceOpen; });
          serviceDialog.showModal(); serviceDialog.scrollTop = 0;
        });
      });
      serviceDialog.querySelector('[data-service-close]').addEventListener('click', () => serviceDialog.close());
      serviceDialog.addEventListener('close', () => serviceOpener?.focus());
      serviceDialog.addEventListener('click', event => {
        if (event.target !== serviceDialog) return;
        const r = serviceDialog.getBoundingClientRect();
        if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) serviceDialog.close();
      });
      const dock = page.querySelector('[data-purchase-dock]');
      const hero = page.querySelector('.product-gallery');
      if (hero && 'IntersectionObserver' in window) {
        new IntersectionObserver(entries => { dock.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(hero);
      }
      const select = content.querySelector('[data-variant]');
      if (!select) return;
      const tiles = document.createElement('div');
      tiles.className = 'mas-variant-tiles'; tiles.setAttribute('role', 'group');
      tiles.setAttribute('aria-label', 'Choose a size or product option');
      [...select.options].forEach(option => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = option.textContent;
        button.dataset.variantId = option.value;
        button.addEventListener('click', () => {
          if (select.disabled || select.closest('form').dataset.busy === 'true') return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        });
        tiles.append(button);
      });
      select.after(tiles); select.hidden = true;
      const sync = () => {
        [...tiles.children].forEach((button, i) => {
          button.setAttribute('aria-pressed', String(button.dataset.variantId === select.value));
          button.disabled = select.disabled || select.options[i].dataset.available !== 'true';
        });
        const price = page.querySelector('[data-hero-price]');
        if (price) price.textContent = select.selectedOptions[0]?.dataset.price || '';
        const dockPrice = page.querySelector('[data-dock-price]');
        if (dockPrice && price) dockPrice.textContent = price.textContent;
      };
      select.addEventListener('change', sync);
      new MutationObserver(sync).observe(select, {attributes: true, attributeFilter: ['disabled']});
      sync();
      // Close the fit drawer before the existing shopping bag opens.
      document.addEventListener('masnuat:added', () => { if (dialog.open) dialog.close(); }, true);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
